<template>
    <div>
      <section class="content">
        <div class="box info-box">
          <div class="box-header with-border">
            Search By
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
                <div class="form-group">
                  <label for="Branch">Branch</label>
                  <v-select v-model="branchRecord" name="branch_id" label="name" :options="branches" v-on:input="getRecordByBranch" placeholder="Select Branch"></v-select>
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Employee ID <span class="red">*</span></label>
                  <v-select v-model="staffRecord" name="employee_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getRecordByEmployee">
    
                  </v-select>
                  <has-error
                    :form="form"
                    field="agent_id"
                  ></has-error>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- Default box -->
          <div class="info-box"  v-if="canAccess('employee-Leave-view-any')">
            <div class="box-header with-border">
              <h3 class="box-title">Employee Members Transfer Record List</h3>
              
              <div class="box-tools">
                <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('employee-Leave-create')">
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
    
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-6 col-xs-6">
                  <label>
                    <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label>
                </div>
                <div class="col-sm-6 col-xs-6">
                  <div class="input-group pull-right input-group-sm" style="width: 150px;">
                    <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">
    
                    <div class="input-group-btn">
                      <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>
              <table class="table table-sm table-bordered table-hover">
                <thead style="background-color: #d6dddd;">
                  <tr>
                    <th class="hidden-xs">Sr. No.</th>
                    <th>New Employee</th>
                    <th class="hidden-xs">Previous Employee</th>
                    <th class="hidden-xs">Branch</th>
                    <th class="hidden-xs">Collection Center</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in rows.data" :key="index">
                    <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                    <td><i v-if="row.employee">{{ row.employee.name }} ({{ row.employee.code}})</i></td>
                    <td class="hidden-xs"><i v-if="row.previous_employee">{{ row.previous_employee.name }} ({{ row.previous_employee.code}})</i></td>
                    <td class="hidden-xs"><i v-if="row.branch">{{ row.branch.name }}</i></td>
                    <td class="hidden-xs"><i v-if="row.collection_center">{{ row.collection_center.name }} ({{ row.collection_center.centerCode
     }})</i></td>
                  </tr>
                </tbody>
              </table>
                    
            </div>
            <!-- /.box-body -->
            <div class="box-footer clearfix" v-if="pagination.current_page > 0">
              <div class="row">
                <div class="col-sm-4">
                  Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
                </div>
                <div class="col-sm-8">
                  <ul class="pagination pagination-sm no-margin pull-right">
                    <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                    <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>
    
                    <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                    <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                    <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                    <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                    <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                    <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                    <li><a href="#">...</a></li>
                    
                    <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                    <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                    <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>
    
                    <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                    <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box -->
      </section>    
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Add New</h4>
              <h4 v-show="editMode" class="modal-title">Update</h4>
              
            </div>
            <form @submit.prevent="editMode ? updateAbsent() : createEmployeeTransfer()">
              <div class="modal-body">
                <!-- general form elements disabled -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label
                            >Select Transfer Type <span class="red">*</span></label
                          >
                          <select
                            v-model="form.transferType"
                            name="transferType"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('transferType'),
                            }"
                            required
                          >
                            <option v-if="!form.transferType" selected value="">
                              Select Transfer Type
                            </option>
                            <option value="">None</option>
                            <!-- <option value="branch">Branch</option> -->
                            <option value="agent">Staff</option>
                            <!-- <option value="collectionCenter">Collection Center</option> -->
                          </select>
                          <has-error :form="form" field="transferType"></has-error>
                        </div>
                        <!-- text input -->
                        <div class="form-group">
                          <label for="Branch">Branch <span class="red">*</span></label>
                          <v-select v-model="branch" name="branch_id" label="name" :options="branches" v-on:input="loadStaff" placeholder="Select Branch"></v-select>
                          <has-error
                            :form="form"
                            field="branch_id"
                          ></has-error>
                        </div>
                        <div class="form-group" v-if="form.transferType === 'branch'">
                          <label for="Branch">New Branch <span class="red">*</span></label>
                          <v-select v-model="newbranch" name="new_branch_id" label="name" :options="branches" v-on:input="loadStaff" placeholder="Select New Branch"></v-select>
                          <has-error
                            :form="form"
                            field="new_branch_id"
                          ></has-error>
                        </div>
                        
                      </div>
    
                      <div class="col-sm-6">
                        <div class="form-group">
                            <label>Previous Employee ID <span class="red">*</span></label>
                            <v-select v-model="previousStaff" name="previous_employee_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getPreviousEmployeeDetails">
    
                            </v-select>
                            <has-error
                            :form="form"
                            field="previous_employee_id"
                            ></has-error>
                        </div>
                        <div class="form-group">
                            <label>New Employee ID <span class="red">*</span></label>
                            <v-select v-model="staff" name="new_employee_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getNewEmployeeDetails">
    
                            </v-select>
                            <has-error
                            :form="form"
                            field="new_employee_id"
                            ></has-error>
                        </div>
                        <!-- <div class="form-group" v-if="branch">
                          <label
                            >Change Collection Center only? <span class="red">*</span></label
                          >
                          <select
                            v-model="form.checkCollectionCenter"
                            name="checkCollectionCenter"
                            @change="getCollectionCenter"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('checkCollectionCenter'),
                            }"
                          >
                            <option v-if="!form.checkCollectionCenter" selected value="">
                              -Select-
                            </option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </select>
                          <has-error :form="form" field="checkCollectionCenter"></has-error>
                        </div>
                        <div class="form-group" v-if="form.checkCollectionCenter === 'yes'">
                          <label>Collection Center </label>
                          <v-select v-model="collectionCenter"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="selectCollectionCenter" required> 
                          </v-select>
                          <has-error
                            :form="form"
                            field="collection_center_id"
                          ></has-error>
                        </div> -->
                        <div class="form-group">
                          <label
                            >Select Status <span class="red">*</span></label
                          >
                          <select
                            v-model="form.status"
                            name="status"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('status'),
                            }"
                          >
                            <option v-if="!form.status" selected value="">
                              Select Status
                            </option>
                            <option value="active">Active</option>
                            <option value="inActive">Inactive</option>
                          </select>
                          <has-error :form="form" field="status"></has-error>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-success"
                >
                  CREATE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-success">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->   
    </div>
    </template>
    
    <script>
    import GetBranch from '../../mixins/BranchRecords'
    export default {
      name: 'EmployeeMemberTransfer',
      mixins: [GetBranch],
      data () {
        return {
          staffs: [],
          previousStaff: {},
          colC: '',
          staff: {},
          staffRecord: {},
          branches: [],
          branch: {},
          newbranch: {},
          branchRecord: {},
          collectionCenters: [],
          collectionCenter: {},
          pagination: {
            current_page: 0,
            from: 0,
            to: 0,
            total: 0,
            last_page: 0,
            per_page: 0,
            first_page_url: null,
            last_page_url: null,
            next_page_url: null,
            prev_page_url: null,
            path: null
          },
          per_page: 10,
          table_search: '',
          editMode: false,
          form: new Form({
            id: '',
            branch_id: '',
            new_branch_id: '',
            employee_id: '',
            previous_employee_id: '',
            collection_center_id: '',
            checkCollectionCenter: '',
            transferType: '',
            status: ''
          }),
          rows: []
        }
      },
      methods: {
        canAccess (perm) {
          return this.$store.state.permissions.includes(perm)
        },
        newModal () {
          this.editMode = false
          this.form.reset()
          this.branch = {}
          this.staff = {}
          this.previousStaff = {}
          $('#newModal').modal({backdrop: 'static', keyboard: false})
          // $('#newModal').modal('show')
        },
        // getCollectionCenter () {
        //   this.collectionCenters = []
        //   if (this.form.checkCollectionCenter === 'yes') {
        //     this.$axios.get('collectioncenter?all=all&branch_id=' + this.branch.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        //       .then((response) => response.data)
        //       .then((data) => {
        //         this.collectionCenters = data.data
        //         _.forEach(this.collectionCenters, function (item, key) {
        //           this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
        //           if (this.form.collection_center_id === item.id) {
        //             this.colC = item
        //           }
        //         }.bind(this))
        //       })
        //       .catch(
        //         function (error) {
        //           Toast.fire({ icon: 'error', title: 'Please Try Again' })
        //           this.form.errors.errors = error.response.data.error
        //         }.bind(this)
        //       )
        //   }
        // },
        getRecordByBranch () {
          this.form.branch_id = ''
          if (this.branchRecord) {
            this.form.branch_id = this.branchRecord.id
          }
          this.$axios
            .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then((response) => response.data)
            .then((data) => {
              this.staffs = data.data
              _.forEach(this.staffs, function (item, key) {
                this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
                if (this.form.agent_id === item.user.id) {
                  this.staff = item
                }
              }.bind(this))
            })
            .catch(
              function (error) {
                Toast.fire({ icon: 'error', title: 'Please Try Again' })
                this.form.errors.errors = error.response.data.error
              }.bind(this)
            )
          this.changeFilter()
        },
        selectCollectionCenter () {
          this.form.collection_center_id = this.collectionCenter.id
        },
        createEmployeeTransfer () {
          if (this.form.checkCollectionCenter === 'no') {
            this.$delete(this.form, 'collection_center_id')
          }
          this.$axios
            .post('membertransfer', this.form, {
              headers: { Authorization: 'Bearer ' + localStorage.token }
            })
            .then(() => {
              Fire.$emit('AfterCreate')
              $('#newModal').modal('hide')
              Toast.fire({
                icon: 'success',
                title: 'Employee Transfer Record Added Successfully'
              })
            })
            .catch(
              function (error) {
                Toast.fire({ icon: 'error', title: 'Please Try Again' })
                this.form.errors.errors = error.response.data.error
              }.bind(this)
            )
        },
    
        getNewEmployeeDetails () {
          this.form.employee_id = this.staff.user_id
        },
        getPreviousEmployeeDetails () {
          this.form.previous_employee_id = this.previousStaff.user_id
        },
        getRecordByEmployee () {
          this.form.employee_id = this.staffRecord.id
        },
        loadStaff () {
          this.form.branch_id = this.branch.id
          this.form.checkCollectionCenter = 'no'
          this.$axios
            .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then((response) => response.data)
            .then((data) => {
              this.staffs = data.data
              _.forEach(this.staffs, function (item, key) {
                this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
                if (this.form.agent_id === item.user.id) {
                  this.staff = item
                }
              }.bind(this))
            })
            .catch(
              function (error) {
                Toast.fire({ icon: 'error', title: 'Please Try Again' })
                this.form.errors.errors = error.response.data.error
              }.bind(this)
            )
        },
        changeFilter (page = null, pg = null) {
          var pageUrl = ''
          if (this.pagination.first_page_url && pg === 'first') {
            pageUrl += this.pagination.first_page_url
          } else if (this.pagination.last_page_url && pg === 'last') {
            pageUrl += this.pagination.last_page_url
          } else if (this.pagination.next_page_url && pg === 'next') {
            pageUrl += this.pagination.next_page_url
          } else if (this.pagination.prev_page_url && pg === 'prev') {
            pageUrl += this.pagination.prev_page_url
          } else if (this.pagination.path != null) {
            pageUrl += this.pagination.path
          } else {
            pageUrl += 'membertransfer'
          }
    
          if (pg == null) {
            pageUrl += `?per_page=${this.per_page}`
          } else {
            pageUrl += `&per_page=${this.per_page}`
          }
          if (this.form.branch_id) {
            pageUrl += `&branch_id=${this.form.branch_id}`
          }
          if (this.table_search) {
            pageUrl += `&searchTerm=${this.table_search}`
          }
          if (page != null) {
            pageUrl += `&page=${page}`
          }
          this.$axios
            .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              this.rows = data.data
              this.pagination = data.data
            }).catch(function (error) { console.log(error) })
        }
      },
    
      created () {
        this.getBranch()
        this.changeFilter()
        Fire.$on('AfterCreate', () => {
          this.changeFilter()
        })
      }
    }
    </script>
    <style scoped>
    .content {
      padding: 0px;
    }
    .info-box {
        border-radius:10px;
        box-shadow: 0px 0px 4px gray;
      }
      .box-footer {
        border-radius:0px 0px 10px 10px;
      }
      .red {
        color:rgb(245, 9, 9);
      }
    </style>



// WEBPACK FOOTER //
// EmployeeMemberTransfer.vue?83f6c266